import { useNostoAppState, useResponse } from "@nosto/search-js/preact/hooks"
import { SearchPopularSearches } from "@nosto/nosto-js/client"
import styles from "./Results.module.css"
import Keywords from "./Keywords"
import Products from "./Products"
import History from "./History"
import PopularSearches from "./PopularSearches"
import { useRovingFocus } from "@/hooks/useRovingFocus"
import { usePopularProducts } from "@/hooks/usePopularProducts"
import Categories from "./Categories"
import { hardcodedPopularSearches } from "@/config"
import Portal from "@/elements/Portal/Portal"

type ResultsProps = {
  input?: string
  onKeyDown: (e: KeyboardEvent) => void
}

const hardcodedPopularSearchesResponse: SearchPopularSearches = {
  hits: hardcodedPopularSearches.map(query => ({ query })),
  total: hardcodedPopularSearches.length
}

export default function Results({ input = "", onKeyDown }: ResultsProps) {
  const { categories, keywords, products, popularSearches } = useResponse()
  const containerRef = useRovingFocus<HTMLDivElement>(".ns-autocomplete-element")

  const hasResults = !!(
    categories?.hits?.length ||
    keywords?.hits?.length ||
    products?.hits?.length ||
    popularSearches?.hits?.length
  )
  const hasHistory = !!useNostoAppState(state => state.historyItems?.length)
  const isBeforeTyping = !input.trim()
  const popularProducts = usePopularProducts(isBeforeTyping)

  if (!isBeforeTyping && !hasResults && !hasHistory) {
    return null
  }

  const productsToShow = isBeforeTyping ? popularProducts : products
  const showProducts = !!productsToShow?.hits?.length

  return (
    <>
      <Portal target="body">
        <div className={styles.overlay} />
      </Portal>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div className={styles.autocomplete} data-nosto-element="autocomplete" onKeyDown={onKeyDown}>
        <div className={`${styles.container} ${styles.paddingContainer}`} ref={containerRef}>
          <div className={styles.items}>
            <div className={styles.section}>
              {/* {hasHistory && <History />} */}
              {isBeforeTyping ? (
                <PopularSearches searches={hardcodedPopularSearchesResponse} />
              ) : (
                hasResults && (
                  <div className={styles.suggestionsColumn}>
                    <Keywords keywords={keywords} />
                    <Categories categories={categories} />
                  </div>
                )
              )}
            </div>
            {showProducts && <Products products={productsToShow} input={input} showSeeAll={!isBeforeTyping} />}
          </div>
        </div>
      </div>
    </>
  )
}
